import React from 'react';
import Slider from 'slider';
import _TradeNewsContainer from './_TradeNewsContainer.scss';
import TradeNewsItem from 'components/partials/tradenews';
import {Articles} from 'api';
import {Link} from 'react-router-dom';

class TradeNewsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 5,
      order: 'id DESC',
      categoryId: '5a04822ff75c7330ed575c09'
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          categoryId: this.state.categoryId
        }
      }
    };
    Articles.actions.list.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    const settings = {
      className: 'slider variable-width trade-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      <section className='center'>
        <div className='trade-category-container'>
          <div className='trade-left-content'>
            <p className='title-black'>Thông tin thương mại</p>
            <p className='view-more'>
              <Link to={`/news-category/${this.state.categoryId}`} className='view-more-link'>Xem thêm</Link>
            </p>
          </div>
          <div className='trade-right-content'>
            <Slider {...settings}>
              {this.state.data.map((item, i) => {
                return (
                  <div key={i}>
                    <TradeNewsItem {...item}/>
                  </div>
                )
              })
}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default TradeNewsContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/TradeNewsContainer.jsx